// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3o9Fq","textarea":"Form_textarea__CZeuI","checkbox":"Form_checkbox__3ATwM","message":"Form_message__1jn3A"};